<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner';

defineProps<{ loading: boolean }>();
</script>
<template>
  <div v-if="loading" class="loading-mask">
    <ProgressSpinner
      style="width: 75px; height: 75px; z-index: 1001"
      stroke-width="3"
      fill="transparent"
      animation-duration="1s"
      :pt="{
        circle: {
          style: {
            stroke: '#000 !important'
          }
        }
      }"
    />
  </div>
</template>
<style scoped>
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
}
</style>
